import { render, staticRenderFns } from "./ViewContent.vue?vue&type=template&id=8c2da730&scoped=true"
import script from "./ViewContent.vue?vue&type=script&lang=js"
export * from "./ViewContent.vue?vue&type=script&lang=js"
import style0 from "./ViewContent.vue?vue&type=style&index=0&id=8c2da730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2da730",
  null
  
)

export default component.exports